import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFileStorageItemDownload } from "../../api/filestorageApi";
import { downloadFile } from "../../helpers/fileDownloadHelper";
import AdditionalInfo from "../AdditionalInfo/AdditionalInfo";
import {
  Archive,
  FileEarmark,
  FileEarmarkBinary,
  FileEarmarkCheck,
  PatchCheck,
  PatchExclamation,
} from "react-bootstrap-icons";
import { getTextWithCapitalizedFirstLetter } from "../../helpers/textHelper";

interface FileProps {
  id: number;
  fileName: string;
  fileSize?: number;
  fileChecksum?: string;
  signed?: boolean;
  type?: string;
}

interface FileContainerProps {
  file: FileProps;
  onFetchError: Function;
  onDownloadError: Function;
}

export default function FileContainer(props: FileContainerProps) {
  const [downloading, setDownloading] = useState(false);
  const { t } = useTranslation();

  const donwloadFile = () => {
    setDownloading(true);
    getFileStorageItemDownload(
      props.file.id,
      (responseData: SetStateAction<any>) => {
        downloadFile(
          props.file.fileName,
          responseData.downloadLink,
          () => {
            setDownloading(false);
            props.onDownloadError("");
            props.onFetchError("");
          },
          (errorText: React.SetStateAction<string>) => {
            setDownloading(false);
            props.onDownloadError(errorText);
          }
        );
      },
      (errorText: React.SetStateAction<string>) => {
        setDownloading(false);
        props.onFetchError(errorText);
      }
    );
  };

  return (
    <AdditionalInfo
      infoFields={[
        {
          icon: <FileEarmark />,
          title: props.file.fileName,
        },
        {
          icon: <Archive />,
          title: props.file.fileSize
            ? props.file.fileSize + " " + t("bytes")
            : "",
        },
        {
          icon: <FileEarmarkCheck />,
          title: props.file.fileChecksum ? props.file.fileChecksum : "",
        },
        {
          icon: props.file.signed ? <PatchCheck /> : <PatchExclamation />,
          title: props.file.signed
            ? props.file.signed === true
              ? t("Signed")
              : t("Unsigned")
            : "",
        },
        {
          icon: <FileEarmarkBinary />,
          title: props.file.type
            ? t(getTextWithCapitalizedFirstLetter(props.file.type))
            : "",
        },
      ]}
      buttons={[
        {
          title: "Download",
          variant: "outline-primary",
          action: () => {
            donwloadFile();
          },
          withSpinner: true,
          disabled: downloading,
        },
      ]}
    />
  );
}
